import { FC } from 'react';

import * as Yup from 'yup'
import {useFormik} from 'formik'

import { FileUploader, FileUploaderResponse, StatusErrorMessage } from '../../../../../components/widgets';
import { doFormSubmit } from '../../../../../components/helpers';
import { SubmitButtonComponent } from '../../../../../components/layout';
  
interface IApplicationTerminateRequest {    
  attachmentId: number
  attachmentName?: string    
  note: string   
  cancelRequest: boolean     
}

const ApplicationTerminateModalSchema:  any = Yup.object({                
  note: Yup.string().trim().required('Details required.').label('Notes'),        
  attachmentId: Yup.number().integer().moreThan(0,'Attachment required').required().label('Attachment'),
});

const initValues: IApplicationTerminateRequest = {    
  attachmentId: 0,
  attachmentName: '',
  note: '',      
  cancelRequest: false,    
};

type Props = {
  appID: number
  siteID?: number
  onSuccess: Function
  onCancel: Function
}

const DLMApplicationTerminateModalForm : FC<Props> = ({appID, siteID, onSuccess, onCancel}) => {
  
  const formik = useFormik({
    initialValues: initValues,
    validationSchema: ApplicationTerminateModalSchema,    
    onSubmit: async (values, {setStatus, setSubmitting}) => {                 
        
      const params = { 
        applicationid : appID,
        note: values.note,
        cancelRequest: false
      }

      if (siteID && siteID > 0) {
        Object.assign(params, { siteApplicationid: siteID });
      }

      if (values.attachmentId && values.attachmentId > 0) {
        Object.assign(params, { 
            attachmentId: values.attachmentId
        });
      }

      await doFormSubmit('TerminateDLMApplicationServlet', params, setStatus, setSubmitting, () => {
        onSuccess();
      });
    }                    
  })

  const { 
      attachmentName, 
  } = formik.values;
  
  return (
  <>
  <form id='kt_doclabel_application_terminate_modal_form' className='form' onSubmit={formik.handleSubmit} noValidate>
    {/* begin::Scroll */}
    <div
      className='d-flex flex-column gap-4 scroll-y my-6 pe-2'
      id='kt_doclabel_application_terminate_modal_scroll'
      data-kt-scroll='true'
      data-kt-scroll-activate='{default: false, lg: true}'
      data-kt-scroll-max-height='auto'
      data-kt-scroll-dependencies='#kt_doclabel_application_terminate_modal_header'
      data-kt-scroll-wrappers='#kt_doclabel_application_terminate_modal_scroll'
      data-kt-scroll-offset='300px'
    >                                                
      { (siteID && siteID > 0) ? (
        <h4>{`Are you sure you want to Terminate Site Application No. ${siteID} (App No : ${appID})`}</h4>
      ) : (
        <h4>{`Are you sure you want to Terminate Application No. ${appID}`}</h4>
      )}                            
      <div className='fv-row mb-4'>
        <label className='col-form-label fw-bold fs-6'>
          <span className='required'>Reason: </span>                    
        </label>                
        <textarea
          placeholder='Enter reason'
          {...formik.getFieldProps('note')}                        
          name='note'                                            
          className='form-control form-control-solid'
          rows={3}                                        
        ></textarea>                
        {(formik.errors.note && formik.errors.note.length > 0) && (
        <div className='fv-plugins-message-container'>                    
          <div className='fv-help-block'>{formik.errors.note}</div>
        </div>
        )}                                                   
      </div>      
      <div className="fv-row mb-4">               
        <FileUploader 
          mainTitle="Attachment"
          subTitle={ attachmentName ? attachmentName : "Click or drop here to upload."}
          fileName={ attachmentName }
          allowMultiple={false} 
          acceptFiles="UserFileFormats"
          onFileUploaded={ (dat: FileUploaderResponse) => {
            formik.setFieldValue("attachmentId", dat.id, false);
            formik.setFieldValue("attachmentName", dat.name, false);                                    
            setTimeout(() => formik.validateField("attachmentId"), 100)                                    
          }}
          onClearFile={ () => {
            formik.setFieldValue("attachmentId", 0, false);
            formik.setFieldValue("attachmentName", '', false);                                    
            setTimeout(() => formik.validateField("attachmentId"), 100)                                    
          }}
          required={true}
        />
        {formik.touched.attachmentId && formik.errors.attachmentId && (
        <div className='fv-plugins-message-container'>
          <div className='fv-help-block'>
            <span role='alert'>{formik.errors.attachmentId}</span>
          </div>
        </div>
        )}                                                        
      </div>
      
      <StatusErrorMessage status={formik.status} />

      <SubmitButtonComponent 
        formik={formik}
        onCancel={() => onCancel()}
      />      
    </div>
  </form>
  </>
  )
}


export {DLMApplicationTerminateModalForm}